import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Btn, Modal, Input, Textarea, Select, Toggle, ImageField } from "./AdminUI";
import { Plus, Edit2, Trash2 } from "lucide-react";

const CATS = ["Architecture", "Construction", "Interior", "Vastu", "Home Planning", "Construction Cost", "Design Ideas"];
const EMPTY = { title: "", category: "Architecture", excerpt: "", content: "", content_align: "left", featured_image: "", author: "GNONS", status: "draft", featured: false, seo_title: "", seo_description: "" };

export default function BlogAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/blog/admin/all").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!editing.title.trim()) return alert("Title required");
    if (editing.id) await api.put(`/blog/admin/${editing.id}`, editing);
    else await api.post("/blog/admin", editing);
    setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete post?")) { await api.delete(`/blog/admin/${id}`); load(); } };
  const setF = (k, v) => setEditing({ ...editing, [k]: v });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-ink">Blog <span className="text-muted text-base">({items.length})</span></h1>
        <Btn onClick={() => setEditing({ ...EMPTY })} data-testid="add-blog-btn"><Plus size={16} /> New Post</Btn>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p) => (
          <div key={p.id} className="rounded-xl2 bg-white border border-line overflow-hidden">
            {p.featured_image && <div className="relative aspect-video bg-sand"><img src={p.featured_image} alt="" className="img-cover" /></div>}
            <div className="p-4">
              <div className="flex items-center gap-2"><span className="text-[10px] text-gold font-bold uppercase">{p.category}</span><span className={`text-[10px] px-2 py-0.5 rounded-full ${p.status === "published" ? "bg-green-100 text-green-700" : "bg-beige text-muted"}`}>{p.status}</span></div>
              <h3 className="font-bold text-ink text-sm mt-1">{p.title}</h3>
              <div className="flex gap-2 mt-3"><Btn variant="outline" onClick={() => setEditing({ ...EMPTY, ...p })}><Edit2 size={14} /> Edit</Btn><Btn variant="danger" onClick={() => del(p.id)}><Trash2 size={14} /></Btn></div>
            </div>
          </div>
        ))}
      </div>
      {editing && (
        <Modal wide title={editing.id ? "Edit Post" : "New Post"} onClose={() => setEditing(null)}>
          <div className="grid md:grid-cols-2 gap-4">
            <Input label="Title *" value={editing.title} onChange={(v) => setF("title", v)} />
            <Select label="Category" value={editing.category} onChange={(v) => setF("category", v)} options={CATS} />
            <Input label="Author" value={editing.author} onChange={(v) => setF("author", v)} />
            <Select label="Status" value={editing.status} onChange={(v) => setF("status", v)} options={["draft", "published"]} />
          </div>
          <div className="mt-4"><ImageField label="Featured Image" value={editing.featured_image} onChange={(v) => setF("featured_image", v)} folder="gnons/blog/" /></div>
          <div className="grid gap-4 mt-4">
            <Textarea label="Excerpt" value={editing.excerpt} onChange={(v) => setF("excerpt", v)} />
            <Textarea label="Content" value={editing.content} onChange={(v) => setF("content", v)} rows={8} align={editing.content_align} onAlign={(v) => setF("content_align", v)} />
          </div>
          <div className="mt-4"><Toggle label="Featured" checked={editing.featured} onChange={(v) => setF("featured", v)} /></div>
          <div className="flex justify-end gap-3 mt-6"><Btn variant="outline" onClick={() => setEditing(null)}>Cancel</Btn><Btn onClick={save} data-testid="save-blog-btn">Save</Btn></div>
        </Modal>
      )}
    </div>
  );
}
